export const ComplementosFecha = [
    {
        codigo: 1,
        nombre: "IGUAL"
    },
    {
        codigo: 2,
        nombre: "DIFERENTE"
    },
    {
        codigo: 3,
        nombre: "ANTERIOR"
    }, {
        codigo: 4,
        nombre: "POSTERIOR"
    },
    {
        codigo: 5,
        nombre: "ANTERIOR IGUAL"
    }, {
        codigo: 6,
        nombre: "POSTERIOR IGUAL"
    }];

export const obtenerCodigoEnvio = (codigo: number) => {
    return ComplementosFecha.find(complemento => complemento.codigo === codigo);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/modelo/ComplementosFecha.ts